import { render, staticRenderFns } from "./CustomerRouteForm.vue?vue&type=template&id=3a71a2d4&scoped=true&"
import script from "./CustomerRouteForm.vue?vue&type=script&lang=js&"
export * from "./CustomerRouteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71a2d4",
  null
  
)

export default component.exports